import React, { useState } from "react";
import axios from "../../axiosConfig";
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faEnvelope, 
  faKey, 
  faExclamationCircle, 
  faCheckCircle, 
  faPaperPlane
} from '@fortawesome/free-solid-svg-icons';
import Header from '../../components/Header';
import '../../styles/AuthPages.css';

const UserEmailRegister = () => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState('');
  const [isVerifying, setIsVerifying] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [countdown, setCountdown] = useState(0);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSendOtp = async () => {
    // 验证邮箱格式
    if (!/^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(email)) {
      setError('请输入有效的邮箱地址');
      return;
    }
    
    setIsSending(true);
    setError('');
    
    try {
      const response = await axios.post(
        "/email-otp/send",
        null,
        { params: { email } }
      );
      
      if (response.data.code === 0) {
        setMessage("验证码已发送到您的邮箱，请注意查收");
        setIsOtpSent(true);
        // 开始60秒倒计时
        setCountdown(60);
        const timer = setInterval(() => {
          setCountdown(prev => {
            if (prev <= 1) {
              clearInterval(timer);
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      } else {
        setError(response.data.msg || "发送验证码失败");
      }
    } catch (error) {
      setError("发送验证码失败：" + (error.response?.data?.msg || "网络错误"));
    } finally {
      setIsSending(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    
    if (!otp || otp.length < 4) {
      setError('请输入完整的验证码');
      return;
    }
    
    setIsVerifying(true);
    setError('');
    
    try {
      const response = await axios.post(
        "/email-otp/verify",
        null,
        { params: { email, otp } }
      );
      
      if (response.data.code === 0) {
        setMessage("验证成功！");
        // 继续注册/登录流程
        await checkEmail(email);
      } else {
        setError(response.data.msg || "验证码错误");
      }
    } catch (error) {
      setError("验证失败：" + (error.response?.data?.msg || "网络错误"));
    } finally {
      setIsVerifying(false);
    }
  };

  // 检查邮箱是否存在于数据库中
  const checkEmail = async (email) => {
    try {
      const response = await axios.get(`/yonghu/findByEmail?youxiang=${encodeURIComponent(email)}`);
      
      if (response.data.code === 0) {
        // 如果邮箱存在，直接登录
        await loginUser(response.data.data.zhanghao, response.data.data.mima);
      } else {
        // 如果邮箱不存在，创建新用户
        await registerUser(email);
      }
    } catch (error) {
      console.error('Error checking email:', error);
      // 邮箱不存在，创建新用户
      await registerUser(email);
    }
  };

  // 登录用户
  const loginUser = async (zhanghao, mima) => {
    const params = new URLSearchParams();
    params.append('username', zhanghao);
    params.append('password', mima);
    
    try {
      const response = await axios.post('/yonghu/login', params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      
      if (response.data.code === 0) {
        const { userId, token } = response.data;
        const userData = { id: userId, zhanghao, role: 'yonghu' };

        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('userData', JSON.stringify(userData));
        
        login(userData, token);
        
        // 获取用户详情
        try {
          const userResponse = await axios.get(`/yonghu/info/${userId}`);
          if (userResponse.data.code === 0) {
            const fullUserData = {
              ...userData,
              ...userResponse.data.data
            };
            
            localStorage.setItem('user', JSON.stringify(fullUserData));
            localStorage.setItem('userData', JSON.stringify(fullUserData));
            login(fullUserData, token);
          }
        } catch (err) {
          console.error("获取用户详情失败:", err);
        }
        
        // 跳转到用户详情页
        navigate(`/users/${userId}`);
      } else {
        setError(response.data.msg || '登录失败');
      }
    } catch (err) {
      console.error('登录失败:', err);
      setError('登录请求失败');
    }
  };

  // 注册用户
  const registerUser = async (email) => {
    const formData = {
      zhanghao: email,
      mima: generateRandomPassword(),
      xingming: email.split('@')[0], // 使用邮箱前缀作为姓名
      xingbie: '',
      shouji: '',
      youxiang: email,
      loginType: 'email',
      dizhi: '',
      tupian: '',
      addtime: '',
    };
    
    try {
      const response = await axios.post('/yonghu/register', {
        ...formData,
        id: '',
      });

      if (response.data.code === 0) {
        alert("注册成功！");
        await loginUser(email, formData.mima);
      } else {
        setError(response.data.msg || '注册失败');
      }
    } catch (err) {
      console.error('Error registering user:', err);
      setError('注册请求失败，请稍后重试');
    }
  };

  const generateRandomPassword = () => {
    return Math.random().toString(36).slice(-8);
  };

  return (
    <div className="home-page">
      <Header />
      <div className="auth-container">
        <div className="auth-header">
          <h1>邮箱验证登录</h1>
          <p>使用邮箱快速登录或注册</p>
        </div>
        
        {message && !error && (
          <div className="auth-message">
            <FontAwesomeIcon icon={faCheckCircle} /> {message}
          </div>
        )}
        
        {error && (
          <div className="auth-error">
            <FontAwesomeIcon icon={faExclamationCircle} /> {error}
          </div>
        )}
        
        <form className="auth-form" onSubmit={handleVerifyOtp}>
          <div className="form-group">
            <label htmlFor="email">
              <FontAwesomeIcon icon={faEnvelope} /> 邮箱地址
            </label>
            <div className="otp-container">
              <input
                id="email"
                type="email"
                className="otp-input"
                placeholder="请输入邮箱地址"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={isOtpSent}
              />
              <button 
                type="button" 
                className="otp-btn"
                onClick={handleSendOtp}
                disabled={isSending || isOtpSent && countdown > 0}
              >
                {isSending ? '发送中...' : 
                 countdown > 0 ? `${countdown}秒` : '发送验证码'}
              </button>
            </div>
          </div>
          
          {isOtpSent && (
            <div className="form-group">
              <label htmlFor="otp">
                <FontAwesomeIcon icon={faKey} /> 验证码
              </label>
              <input
                id="otp"
                type="text"
                placeholder="请输入邮箱验证码"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                required
              />
            </div>
          )}
          
          {isOtpSent && (
            <button 
              type="submit" 
              className="auth-btn"
              disabled={isVerifying}
            >
              {isVerifying ? '验证中...' : '验证并登录'}
              {!isVerifying && <FontAwesomeIcon icon={faPaperPlane} style={{ marginLeft: '8px' }} />}
            </button>
          )}
        </form>
        
        <div className="auth-links">
          <Link to="/mobile-register">使用手机号登录</Link>
          <Link to="/login">使用账号密码登录</Link>
          <Link to="/register">注册新账号</Link>
        </div>
      </div>
    </div>
  );
};

export default UserEmailRegister; 